Customer.Dashboard ||= {}

class Customer.Dashboard.SummarySortingView extends Backbone.View
  template: JST["backbone/templates/customer/dashboard/summary/main/header/summary_sorting"]

  initialize: (@options = {}) ->
    @order_by = @options.order_by || throw new Error('Cannot instantiate a SummarySortingView without an order_by object')

  render: ->
    @$el.html(@template(order_by: @order_by))
    @$el.find('#sorting-direction').on('click', @toggleDirection)
    @$el.find('#sorting-criteria').on('change', @changeSortingCriteria)
    @hideSpinner()
    @

  onChangeOrderBy: ->
    @trigger('search:settings:changed', @order_by)

  toggleDirection: (event) =>
    @order_by.order = if @order_by.order == 'asc' then 'desc' else 'asc'
    @hideSortingDirection()
    @showSpinner()
    @onChangeOrderBy()

  changeSortingCriteria: (event) =>
    @order_by.value = event.target.value
    @hideSortingDirection()
    @showSpinner()
    @onChangeOrderBy()

  hideSortingDirection:=>
    @$el.find('#sorting-direction').hide()

  showSpinner: =>
    @$el.find('.ticket-sorting-loading').show()

  hideSpinner: =>
    @$el.find('.ticket-sorting-loading').hide()

  getOrderBy: ->
    @order_by || { order: 'desc', value: 'latest_content_date' }

  show: () ->
    @$el.css(display: 'block')

  hide: () ->
    @$el.css(display: 'none')
